module.exports = __webpack_public_path__ + "static/media/DCLogoVector2.b2605fa2.svg";